<template>
    <div class="becas">
        <vs-row class="cardGeneral">
            <vs-col class="cardReportes" vs-type="flex" vs-justify="center" vs-align="center" w="12">
                <h4 class="p-2">Gestión de becas</h4>
                <vs-row class="mt-4">
                    <vs-col sm="12" lg="3">
                        <form autocomplete="off">
                            <label for="institucion" class="labelInput">
                                Institución
                            </label>
                            <vs-select filter class="aqui pt-0" id="institucion" placeholder="Seleccionar Institución" :key="institucionId" v-model="institucion" :disabled="!instituciones.length" autocomplete="off">
                                <template #message-danger v-if="errorFields.includes('institucion')">
                                    Requerido
                                </template>
                                <vs-option v-for="option in instituciones" :key="option.id"  :label="option.text" :value="option.id">
                                    {{option.text}}
                                </vs-option>
                            </vs-select>
                        </form>
                    </vs-col>
                    <vs-col sm="12" lg="3">
                        <form autocomplete="off">
                            <label class="labelInput">Nombre</label>
                            <vs-input  type="text" class="pt-0"
                                v-model="nombre"
                                placeholder="Nombre" >
                            </vs-input>
                        </form>
                    </vs-col>
                    <vs-col sm="12" lg="3" style="margin-top: 23px; display: flex">
                        <vs-button
                            @click="getInfoGestionBecas()"
                        >
                            <i class="fas fa-search mr-2"></i>Buscar
                        </vs-button>
                    </vs-col>
                </vs-row>
                <vs-row>
                    <vs-col sm="12" lg="3" class="ml-auto">
                        <vs-button
                            success
                            class="ml-auto"
                            @click="activeCrear = ! activeCrear "
                        >
                            <i class="fas fa-plus mr-2"></i> Crear registro
                        </vs-button>
                    </vs-col>
                    <vs-col sm="12" lg="12">
                        <vs-row>
                            <vs-col sm="12" lg="3" class="ml-auto">
                                <vs-input v-model="search" placeholder="Buscar">
                                    <template #icon>
                                        <i class="fas fa-search"></i>
                                    </template>
                                </vs-input>
                            </vs-col>
                        </vs-row>
                        <vs-table>
                            <template #thead>
                                <vs-tr>
                                    <editar v-model="activeEditar" :selectInfo="selectInfo" :institucionSelect="institucion" :instituciones="instituciones" :institucionId="institucionId"  @refreshTable="getRefresh"></editar>
                                </vs-tr>
                                <vs-tr>
                                    <vs-th width="230px" sort @click="users = $vs.sortData($event ,users, 'nombre')">
                                        Nombre
                                    </vs-th>
                                    <vs-th sort @click="users = $vs.sortData($event ,users, 'email')">
                                        Categoría
                                    </vs-th>
                                    <vs-th  width="250px" sort @click="users = $vs.sortData($event ,users, 'id')">
                                        Alcance
                                    </vs-th>
                                    <vs-th sort @click="users = $vs.sortData($event ,users, 'id')">
                                        Descuento
                                    </vs-th>
                                    <vs-th>
                                        Acciones
                                    </vs-th>
                                </vs-tr>
                            </template>
                            <template #tbody>
                                <vs-tr
                                    :key="i"
                                    v-for="(tr, i) in $vs.getSearch(users, search)"
                                    :data="tr"
                                >
                                    <vs-td>
                                        <p class="mb-0"><strong>{{ tr.nombre }}</strong></p>
                                        <p class="mb-0" style="color: gray"><small style="text-transform: uppercase">Clave: </small><strong>{{ tr.clave }}</strong></p>
                                    </vs-td>
                                    <vs-td>
                                        <p class="mb-0"><strong>{{tr.categoria.nombre}}</strong></p>
                                    </vs-td>
                                    <vs-td>
                                        <p class="mb-0 text-uppercase"><strong>{{tr.alcance}}</strong></p>
                                        <p class="mb-0" style="color: gray" v-if="tr && tr.programa && tr.programa.nombre"><small style="text-transform: uppercase">Programa: </small><strong>{{ tr.programa.nombre }}</strong></p>
                                        <p class="mb-0" style="color: gray" v-if="tr && tr.nivel_academico && tr.nivel_academico.nivel"><small style="text-transform: uppercase">Nivel Académico: </small><strong>{{ tr.nivel_academico.nivel }}</strong></p>
                                    </vs-td>
                                    <vs-td class="text-center">
                                        <md-chip class="mb-1 fontMedium mini-chip" :class="getPorcentaje(tr.porcentaje)"><strong>{{tr.porcentaje}} %</strong></md-chip>
                                    </vs-td>
                                    <vs-td>
                                        <vs-row>
                                            <vs-col sm="6" lg="6"> 
                                                <vs-button
                                                    icon
                                                    success
                                                    size="mini"
                                                    class="m-auto"
                                                    @click="activeEditar = ! activeEditar, selectInfo = tr"
                                                >
                                                    <i class="far fa-edit" style="font-size: 10px"></i>
                                                </vs-button>
                                            </vs-col>
                                            <!-- <vs-col sm="6" lg="6">
                                                <vs-button
                                                    icon
                                                    danger
                                                    size="mini"
                                                    class="m-auto"
                                                    @click="activeEliminar = ! activeEliminar, selectInfo = tr"
                                                >
                                                    <i class="far fa-trash-alt" style="font-size: 10px"></i>
                                                </vs-button>
                                            </vs-col> -->
                                        </vs-row>
                                    </vs-td>
                                </vs-tr>
                            </template>
                            <template #footer>
                                <vs-pagination v-model="page" :length="pages" />
                            </template>
                        </vs-table>
                    </vs-col>
                </vs-row>
                <crear v-model="activeCrear" :institucionSelect="institucion" :instituciones="instituciones" :institucionId="institucionId" @refreshTable="getRefresh"></crear>
                <vs-alert v-if="mostrar">
                    <template #title>
                        No se encontro información
                    </template>
                </vs-alert>
            </vs-col>
        </vs-row>
    </div>
</template>

<script>
import academico from '../../../../api/requests/academico'
import crear from './modales/crear.vue'
import editar from './modales/editar.vue'
export default {
    data(){
        return{
            institucion: '',
            institucionId: (new Date()).getTime(),
            instituciones: [],
            loadingInstitucion: false,
            nombre: '',
            errorFields: [],
            users:[],
            mostrar: false,
            activeCrear: false,
            tipoOpcion: '',
            search: '',
            users: [],
            page: 1, 
            max: 10,
            pages: 0,
            activeEditar: false,
            selectInfo: []
        }
    },
    components:{
        crear,
        editar
    },
    created(){
        this.getInstituciones()
    },
    methods:{
        async getInstituciones(){
            this.loadingInstitucion = true
            try {
                const response = await academico.getInstitucion()
                this.instituciones = response.data
                this.institucionId = (new Date()).getTime()
                this.loadingInstitucion = false
                if(this.institucion.length == 1){
                    this.institucion = this.instituciones[0].id
                }
            }
            catch(error){
                console.error(error)
                this.loadingInstitucion = false
            }
        },
        checkByType (type, val) {
            switch (type) {
                case 'string':
                    if (val && val.constructor.name === 'String' && val.trim()) {
                        return true
                    }
                case 'number':
                    if (val && val.constructor.name === 'Number' && val > 0) {
                        return true
                    } 
                case 'array':
                    if (Array.isArray(val) && val.length){
                        return true
                    }
            }
            return false
        },
        sanityForm () {
            this.errorFields = []
            if (!this.checkByType ('string', this.institucion)) {
                this.errorFields.push('institucion')
            }
            if (!this.errorFields.length){
                return {
                    institucion_id: this.institucion,
                    nombre: this.nombre,
                    page: this.page
                }
            } else {
                return null
            }
        },
        async getInfoGestionBecas(){
            const info = this.sanityForm()
            if(info){
                try{
                    const loading = this.$vs.loading()
                    const { data: response } = await academico.getInfoBecas(info)
                    const { data: dataTable = [], per_page = 20, total = 0 } = response || {}
                    this.pages = Math.ceil(total/per_page) || 0
                    this.users = dataTable
                    loading.close()
                }catch{

                }
            }
        },
        getPorcentaje(porcentaje){
            if(porcentaje <= '25'){
                return 'col-green'
            }else if(porcentaje > '25' && porcentaje <= '50'){
                return 'col-blue'
            }else if(porcentaje > '50' && porcentaje <= '75'){
                return 'col-pink'
            }else if(porcentaje > '75'){
                return 'col-yellow'
            }
        },
        async getRefresh(data){
            this.institucion = data
            const params = {
                institucion_id: data,
                nombre: this.nombre,
                page: this.page
            }
            try{
                const loading = this.$vs.loading()
                const { data: response } = await academico.getInfoBecas(params)
                const { data: dataTable = [], per_page = 20, total = 0 } = response || {}
                this.pages = Math.ceil(total/per_page) || 0
                this.users = dataTable
                loading.close()
            }catch{

            }
        }
    },
    watch:{
        page(){
            this.getInfoGestionBecas()
        }
    }
}
</script>

<style>
.becas .vs-table-content .vs-table__footer{
    margin: 2% !important;
}
</style> 

<style lang="scss" scoped>
    .cardReportes{
        width: 100%;
        background-color:white;
        justify-content: space-between;
        @media only screen and (max-width: 768px) {
            margin: 16px;
        }
        @media only screen and (min-width: 768px) {
            margin: 16px 15px;
        }
        border-radius: 3px;
        padding: 10px
    }
    .cardGeneral{
        @media only screen and (max-width: 768px) {
            width: 85%;
        }
        @media only screen and (min-width: 768px) {
            width: 100%;
        }
    }

    .col-yellow{
        background: rgb(255, 248, 236);
        color: #febf3d;
    }

    .col-red{
        color: #f62d51;
        background: rgb(249, 231, 235);
    }

    .col-green{
        color: #55ce63;
        background: rgb(232, 253, 235);
    }

    .col-purple{
        color: purple;
        background: rgb(232, 218, 239);
    }

    .col-blue{
        color: #2874A6;
        background: rgb(214, 234, 248);
    }

    .col-gray{
        color: #5F6A6A;
        background: rgb(242, 243, 244);
    }

    .col-pink{
        color: #F08080;
        background: rgb(255, 236, 236);
    }

    .col-brown{
        color: #784212;
        background: rgb(250, 229, 211);
    }

</style>
